export default __webpack_public_path__ + "static/media/crude-table.8eb230ea.svg";